<div class="title" #title>
  <div class="container container-max-width">
    <div>
      <h4>Review Execution Plan</h4>
      <p>Review the diff between approved and new execution plan versions</p>
    </div>
    <div class="action-container" *ngIf="showActionButtons">
      <button type="submit" class="btn btn-success" (click)="showApprovePlanDialog()" [disabled]="!canApprove" data-test='ApproveButton'>Approve</button>&nbsp;
      <button type="submit" class="btn btn-danger" (click)="showRejectPlanDialog()" [disabled]="!canReject">Reject</button>
      <button *ngIf="isAdminOrOperator" type="button" class="btn btn-delete ms-2" (click)="removePlan()">Remove</button>
    </div>
  </div>
</div>
<div class="container container-content container-max-width" (window:resize)="onResize()" [style.height]="containerHeight">
  <div class="landing-main">
    <fieldset class="fieldsetstyle">
      <div class="top-panel" style="height: fit-content">
        <ul class="list-container col-md-12" *ngIf="planRegion">
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Service Team</div>
            <div class="col-md-10 value">{{ planRegion.ServiceTeam }}&nbsp;({{ planRegion.ServiceTreeId }})</div>
          </li>
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Region</div>
            <div class="col-md-10 value" *ngIf="region != null">{{ planRegion.Region }}&nbsp;({{ region.CloudName}}/{{ region.Status }})</div>
          </li>
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Ring</div>
            <div class="col-md-10 value">{{ planRegion.Ring }}</div>
          </li>
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Version</div>
            <div class="col-md-10 value">
              <a href="{{ planDetailLink }}"
                 class="topbar-item"
                 target="_blank">
                {{ planRegion.Version }}
              </a>
              &nbsp;&nbsp;(
              <b *ngIf="planRegion.Version != latestVersion; else userTemplate">
                Latest version assigned to current region is
                <a href="{{ planLatestVersionReviewLink }}"
                   class="topbar-item"
                   target="_blank">
                  {{ latestVersion }}
                </a>
              </b>
              <ng-template #userTemplate>Latest version assigned to current region</ng-template>)
            </div>
          </li>
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Blueprint</div>
            <div class="col-md-10 value">{{ planRegion.Blueprint }}</div>
          </li>
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Kind</div>
            <div class="col-md-10 value">{{ planRegion.Kind }}</div>
          </li>
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Status</div>
            <div class="col-md-10 value" data-test="PlanRegionStatus">
              {{ showStatus(planRegion) }}
              <span *ngIf="showRejectComment" [ngbTooltip]="planRegion.RejectComment"><i class="fa fa-info-circle"></i></span>
              <div *ngIf="shouldShowFulfillmentLink()" class="mt-1">
                <a href="https://aka.ms/catseye-fulfillment" target="_blank" rel="noopener noreferrer">
                  <i class="fa fa-info-circle"></i> Learn how to fulfill your execution plan
                </a>
              </div>
            </div>
          </li>
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Submitted</div>
            <div class="col-md-10 value">{{ showSubmit(planRegion) }}</div>
          </li>
          <li class="flex-box mb-3">
            <div class="col-md-2 label">Contact Email</div>
            <div class="col-md-10 value">{{ contactEmail }}</div>
          </li>
        </ul>
      </div>
    </fieldset>
    <fieldset class="fieldsetstyle" *ngIf="alternatives?.length > 0">
      <h5>Alternatives</h5>
      <hr />
      <ul class="list-container col-md-12">
        <li class="flex-box mb-3" *ngFor="let original of alternativeOriginals">
          <div class="col-md-2 label"> Overwrite {{original}} </div>
          <ng-container *ngIf="(isAdmin || isGCTApprover) && isGABlueprint; else userTemplate">
            <ng-select style="width: 120px"
                       [items]="alternativeMap[original]"
                       [clearable]="false"
                       [disabled]="!isAdmin && !isGCTApprover"
                       [(ngModel)]="alternativeAssignedMap[original]"
                       [name]="original">
            </ng-select>
            <br />
            <button type="submit" class="btn btn-primary ms-2" [disabled]="(!isAdmin && !isGCTApprover) || !isGABlueprint || fulfillmentStarted" (click)="UpdateAlternativeValue(original)">
              Update
            </button>
          </ng-container>
          <ng-template #userTemplate>
            <div class="col-md-10 value">
              {{ alternativeAssignedMap[original] }}
            </div>
          </ng-template>
        </li>
      </ul>
    </fieldset>
    <fieldset>
      <h5>Tables</h5>
      <hr />
      <div class="card mb-4">
        <div class="card-header">
          <div>
            <span class="bold-font">Approvals</span>
          </div>
        </div>
        <div class="card-block p-3">
          <grid-filter-pills [gridApi]="gridApi" *ngIf="gridApi"></grid-filter-pills>
          <ag-grid-angular #agGrid
                           id="planRegionApprovalsGrid"
                           style="width: 100%; height: 200px"
                           class="ag-theme-balham"
                           [masterDetail]="true"
                           [gridOptions]="planRegionApprovalsGridOptions"
                           [rowData]="planRegionApprovalsRowData"
                           [pagination]="true"
                           (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>

      <div class="card mb-4" style="clear: both">
        <div class="card-header flex-row">
          <div class="float-start">
            <span class="bold-font">Capacity Orders</span>
          </div>
        </div>
        <div class="card-block p-3">
          <ag-grid-angular #agGrid
                           id="capacityOrderGrid"
                           style="width: 100%; height: 120px"
                           class="ag-theme-balham"
                           [gridOptions]="capacityOrderGridOptions"
                           [rowData]="capacityOrderRowData"
                           (gridReady)="onCapacityOrderGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>

      <div class="card mb-4">
        <div class="card-header">
          <div>
            <span class="bold-font">Plan Details</span>
          </div>
        </div>
        <div class="card-block p-3">
          <ag-grid-angular #agGrid
                           id="planDiffGrid"
                           style="width: 100%; height: 320px"
                           class="ag-theme-balham"
                           [masterDetail]="true"
                           [gridOptions]="gridOptions"
                           [rowData]="planDiffRowData"
                           [pagination]="true"
                           (gridReady)="onGridReady($event)">
          </ag-grid-angular>
        </div>
      </div>
    </fieldset>
    <fieldset *ngIf="planRegion">
      <h5>Discussion</h5>
      <hr />
      <div #commentSection class="card mb-2 mt-4" style="clear: both">
        <div class="card-body">
          <plan-comments [serviceTreeId]="serviceTreeId"
                         [region]="regionName"
                         [version]="version"
                         [blueprint]="blueprint"
                         [selectedTopic]="selectedCommentTopic"
                         (commentAdded)="onCommentAdded()">
          </plan-comments>
        </div>
      </div>
    </fieldset>
  </div>
</div>
